import { User as SentryUser } from '@sentry/types/types/user';

import { SENTRY_DSN, ENVIRONMENT_NAME } from '../config';
import { getSentry } from './getSentry';

const initSentry = () =>
	getSentry().init({
		dsn: SENTRY_DSN,
		enableNative: false,
		environment: ENVIRONMENT_NAME,
	});

function setUser(user: SentryUser) {
	return getSentry().setUser(user);
}

function clearUser() {
	return getSentry().getCurrentScope().clear();
}

export { initSentry, setUser, clearUser, getSentry };
